import { render, staticRenderFns } from "./CommodityPortfolioDetailChart.vue?vue&type=template&id=0c3485e6&scoped=true&"
import script from "./CommodityPortfolioDetailChart.vue?vue&type=script&lang=js&"
export * from "./CommodityPortfolioDetailChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3485e6",
  null
  
)

export default component.exports